import React from "react";

export default function ScheduleWalkthrough() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-4 flex flex-col items-center text-center">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-4">
        Schedule a walkthrough
      </h1>
      <p className="text-base sm:text-lg text-slate-300 max-w-2xl mb-8 font-light">
        Pick a time that works for you and we'll show you the platform.
      </p>

      {/* Google Calendar Appointment Scheduling begin */}
      <div className="w-full bg-white rounded-2xl shadow-2xl overflow-hidden border border-purple-500/20">
        <iframe
          src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3_XmIk5mgXnOWoOIrIBWaB4XMxdFxWNBK3lUgTBbsf290Y88y6r-AeGBUl78afS2vMtwLiLBj2?gv=true"
          style={{ border: 0 }}
          width="100%"
          height="600"
          frameBorder="0"
          title="Schedule a walkthrough"
          className="w-full h-[600px] border-0"
        ></iframe>
      </div>
      {/* end Google Calendar Appointment Scheduling */}
    </div>
  );
}
